import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
export const WS_URL = `${BACKEND_URL.replace(/^http/, "ws")}/api/ws`;
export const WHATSAPP_NUMBER = "917092518846";
export const TOKEN_KEY = "araathri_token";
export const ADMIN_PATH = "/rathri-admin";
export const ADMIN_SECRET_PATH = "/admin";
export const APP_NAME = "RATHRI";
export const APP_NAME_ML = "രാത്രി";
export const APP_TAGLINE = "ഒറ്റ ക്ലിക്ക്രാ പകലോ രത്രിയോ.... സൈനപ് / ലോഗിൻ ചെയ്യു.. കാണാം, സംസാരിക്കാം, ചാറ്റാം...";
export const SUPPORT_EMAIL = "erathri06@gmail.com";
export const HEADLINES = [
  "എപ്പോഴും... എവിടെയിരുന്നും... നിങ്ങളുടെ പ്രിയപ്പെട്ടവരുമായി 'രാത്രി'.",
  "ദൂരങ്ങൾ തടസ്സമല്ല; ശബ്ദവും സന്ദേശവും തടസ്സമില്ലാതെ കൈമാറാം.",
  "രാത്രി: അതിരുകളില്ലാത്ത സംഭാഷണങ്ങൾ, എവിടെയും എപ്പോഴും!",
  "നിങ്ങളുടെ പകലോ രാത്രിയോ അടുത്ത സംഭാഷണങ്ങളാൽ കൂടുതൽ മനോഹരമാക്കൂ.",
];

export const api = axios.create({ baseURL: API });
api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem(TOKEN_KEY);
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export const fileUrl = (u) => (u && u.startsWith("/api/") ? `${BACKEND_URL}${u}` : u);

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || "എന്തോ പിഴവ് സംഭവിച്ചു";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return d?.msg || String(d);
}

export const fmtTime = (s = 0) => {
  const v = Math.max(0, Math.floor(s));
  return `${String(Math.floor(v / 60)).padStart(2, "0")}:${String(v % 60).padStart(2, "0")}`;
};
export const fmtMin = (s = 0) => `${(Math.max(0, s) / 60).toFixed(s % 60 ? 1 : 0)} മിനിറ്റ്`;
export const fmtCoins = (c = 0) => `${Number(c).toLocaleString("en-IN", { maximumFractionDigits: 1 })}`;
export const INR_TO_COINS = 6;
export const coinsToInr = (c = 0) => Number(c || 0) / INR_TO_COINS;
export const fmtInr = (c = 0) => `₹${coinsToInr(c).toLocaleString("en-IN", { maximumFractionDigits: coinsToInr(c) % 1 ? 1 : 0 })}`;
export const fmtDate = (s) => new Date(s).toLocaleString("en-IN", { dateStyle: "medium", timeStyle: "short" });

export const copyText = async (v) => {
  try { if (navigator.clipboard?.writeText && window.isSecureContext) { await navigator.clipboard.writeText(v); return true; } } catch (e) { /* fall through */ }
  try {
    const ta = document.createElement("textarea");
    ta.value = v; ta.setAttribute("readonly", ""); ta.style.position = "fixed"; ta.style.top = "-1000px"; ta.style.opacity = "0";
    document.body.appendChild(ta); ta.focus(); ta.select(); ta.setSelectionRange(0, v.length);
    const ok = document.execCommand("copy");
    document.body.removeChild(ta);
    return ok;
  } catch (e) { return false; }
};

export const onDuty = (duty, now = new Date()) => {
  const m = /^(\d{1,2}):(\d{2})-(\d{1,2}):(\d{2})$/.exec((duty || "").trim());
  if (!m) return false;
  const a = +m[1] * 60 + +m[2], b = +m[3] * 60 + +m[4], t = now.getHours() * 60 + now.getMinutes();
  return a <= b ? t >= a && t < b : t >= a || t < b;
};

export const DutyBadge = ({ duty, id }) => (duty ? (
  <p data-testid={`duty-${id}`} className="text-[10px] text-sky-100/90 flex items-center gap-1.5 flex-wrap">
    <span>🕒 {duty}</span>
    {onDuty(duty) && <span data-testid={`on-duty-${id}`} className="rounded-full bg-emerald-500 text-white px-1.5 py-[1px] text-[9px] font-bold inline-flex items-center gap-1"><span className="w-1.5 h-1.5 rounded-full bg-white animate-pulse" />ഇപ്പോൾ ഡ്യൂട്ടിയിൽ</span>}
  </p>
) : null);

export const RULES = [
  "ഡെമോ/ട്രയൽ കോളുകൾ ലഭ്യമായിരിക്കില്ല",
  "ഫോട്ടോകൾ ഷെയർ ചെയ്യുന്നതല്ല",
  "കൺഫർമേഷൻ കോൾ ഉണ്ടായിരിക്കുന്നതല്ല",
  "ഒരു സമയത്ത് ഒരു കസ്റ്റമർ ഒരു സ്റ്റാഫിനോട് മാത്രം",
  "വാങ്ങിയ പാക്കേജ് അതേ സ്റ്റാഫിനോട് തീർത്ത ശേഷം മാത്രം പുതിയത്",
  "ബാലൻസ് തീർന്നാൽ കോൾ സ്വയമേവ വിച്ഛേദിക്കും",
  "ചാറ്റ് സന്ദേശം പരമാവധി 20 അക്ഷരങ്ങൾ",
  "സ്ക്രീൻഷോട്ട് / റെക്കോർഡിംഗ് കർശനമായി നിരോധിച്ചിരിക്കുന്നു",
];
